import { A2kTextField } from "./A2kTextField";
window.customElements.define("a2k-text-field", A2kTextField);
